import { dateExpressionRegex, evaluateDateExpressionString } from "./dateValidation"

export const evaluateConditions = (fieldOrPage, answers: any) => {

    if (!Array.isArray(fieldOrPage.conditions)) {
        return true
    }

    var conditionsSatisfied = fieldOrPage.conditions.filter(conditionDict => {
        return evaluateCondition(conditionDict, answers)
    })

    var result = conditionsSatisfied.length > 0
    // console.log("Conditions result", result)
    return fieldOrPage.conditionsHide ? !result : result
}

export const evaluateCondition = (condition: any, answers: any) => {
    var conditionsSatisfied = Object.keys(condition).filter((fieldName, o) => {
    
        var valueToLookFor = condition[fieldName]

        if (typeof valueToLookFor === "string" && valueToLookFor.match(dateExpressionRegex)) {
            var result = evaluateDateExpressionString(answers, valueToLookFor)
            return !!result
        }

        var answer = answers[fieldName]
        var valuesToLookFor = Array.isArray(valueToLookFor) ? valueToLookFor : [valueToLookFor]
        // This allows us to make reference to values in the answers and define conditions like
        // {
        //      "subject_applying_from": ["$subject_country_of_birth", "$undefined"]
        // }
        valuesToLookFor = valuesToLookFor.map(value => value.startsWith("$") ? answers[value] : value)
        
        return valuesToLookFor.includes(answer)
    })

    var result = conditionsSatisfied.length === Object.keys(condition).length
    // console.log(" - Condition result", result)
    return result
}

export const isHidden = (fieldOrPage, values = {}) => {

    var answers = values

    if (fieldOrPage.conditions) {
        return !evaluateConditions(fieldOrPage, answers)
    }

    var conditionDict = {...fieldOrPage.dependsOn, ...fieldOrPage.dependsOnAny, ...fieldOrPage.hideDependsOn, ...fieldOrPage.hideDependsOnAny}

    var conditionsSatisfied = Object.keys(conditionDict).filter((fieldName) => {
        
        var valueToLookFor = conditionDict[fieldName]

        if (typeof valueToLookFor === "string" && valueToLookFor.match(dateExpressionRegex)) {
            var result = evaluateDateExpressionString(answers, valueToLookFor)
            return !!result
        }

        var answer = answers[fieldName]
        var valuesToLookFor = Array.isArray(valueToLookFor) ? valueToLookFor : [valueToLookFor]
        // This allows us to make reference to values in the answers and define conditions like
        // {
        //      "subject_applying_from": ["$subject_country_of_birth", "$undefined"]
        // }
        valuesToLookFor = valuesToLookFor.map(value => value.startsWith("$") ? answers[value] : value)
        
        return valuesToLookFor.includes(answer)
    })

    if (fieldOrPage.dependsOn) {
        return Object.keys(conditionDict).length !== conditionsSatisfied.length
    }
    if (fieldOrPage.hideDependsOn) {
        return !(Object.keys(conditionDict).length !== conditionsSatisfied.length)
    }

    if (fieldOrPage.dependsOnAny) {
        return conditionsSatisfied?.length === 0
    }
    if (fieldOrPage.hideDependsOnAny) {
        return !(conditionsSatisfied?.length === 0)
    }

    return false
}